import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import type { GetAdminV1StoresStoreIdProductionParams } from '@nucleus-commerce/api-client/admin';

import { productionApi } from '../api/production-api';

import { productionKeys } from './production-keys';

export const BOARD_PAGE_SIZE = 50;

/** The board appends pages with "Load more" instead of paging, so columns keep their cards. */
export function productionBoardQueryOptions(
  storeId: string,
  params: Omit<GetAdminV1StoresStoreIdProductionParams, 'cursor' | 'limit'>,
) {
  const filters = { ...params, limit: BOARD_PAGE_SIZE };
  return infiniteQueryOptions({
    queryKey: productionKeys.board(storeId, filters),
    queryFn: ({ pageParam }) =>
      productionApi.board(storeId, { ...filters, ...(pageParam ? { cursor: pageParam } : {}) }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
}

export function useProductionBoard(
  storeId: string,
  params: Omit<GetAdminV1StoresStoreIdProductionParams, 'cursor' | 'limit'>,
) {
  return useInfiniteQuery(productionBoardQueryOptions(storeId, params));
}
